import axios from "axios";
import { Text } from "components";
import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import { AgGridReact } from "ag-grid-react";
import Pagination from "pages/Pagination/Pagination";
import Select from "react-select";
import { pageSize } from "components/PaginationPageSize";
import { toast } from "react-toastify";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import { formatQuantity, formatRupee } from "utils/helpingMethods/formatRupee";
import Swal from "sweetalert2";

const SupplieritemRevenueReportTest = forwardRef((props, ref) => {
  const [rowData, setRowData] = useState([]);
  const [rowDataToatlAmount, setRowDataToatlAmount] = useState([]);
  const [columnDefs, setColumnDefs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [customerList, setCustomerList] = useState([]);
  const [customerId, setCustomerId] = useState(0);
  const [items, setItems] = useState([]);
  const [searchItemsInput, setSearchItemsInput] = useState("");
  const [searchInput, setSearchInput] = useState("");
  const [selectItem, setSelecteItem] = useState();
  const [selectedOption, setSelectedOption] = useState("Quantity");

  const gridRef = useRef();
  // Get the current date and format it as yyyy-mm-dd for the date input field
  const today = new Date();
  const formattedToday = today.toISOString().split("T")[0];
  const thirtyDaysAgo = new Date(today);
  thirtyDaysAgo.setDate(1); // Set to the first day of the current month
  thirtyDaysAgo.setMonth(thirtyDaysAgo.getMonth() - 2); // Go back one month
  const firstDayOfCurrentMonth = new Date(
    today.getFullYear(),
    today.getMonth(),
    1
  );

  // Format it manually to ensure no timezone shift
  const formattedThirtyDaysAgo = `${firstDayOfCurrentMonth.getFullYear()}-${String(
    firstDayOfCurrentMonth.getMonth() + 1
  ).padStart(2, "0")}-01`;
  const [formDate, setFormDate] = useState(formattedThirtyDaysAgo);
  const [toDate, setToDate] = useState(formattedToday);
  const [recordPerPage, setRecordPerPage] = useState(pageSize);
  const [page, setPage] = useState(1);
  const [offsetforSR, setOffsetforSR] = useState();

  //for pagination...
  const [count, setCount] = useState();
  const [download, setDownload] = useState(false);
  const token = sessionStorage.getItem("token");
  const companyId = sessionStorage.getItem("companyId");
  const companyName = sessionStorage.getItem("companyName");
  // Correct headers format
  const headers = {
    Authorization: `Bearer ${token}`,
  };

  useEffect(() => {
    getCustomerList();
  }, [searchInput]);

  const getCustomerList = () => {
    axios
      .post(
        "/api/purple-fusion/supplier/get",
        { name: searchInput },
        { headers }
      )
      .then((response) => {
        setCustomerList(response.data);
        console.log(response.data);
      })
      .catch((error) => {
        console.error("Error in fetching company purchase items", error);
      });
  };

  useEffect(() => {
    getItemList();
  }, [searchItemsInput]);

  const getItemList = () => {
    const Item_obj = { search_parameter: searchItemsInput };
    axios
      .post("/api/purple-fusion/itemdetail/getforsearch", Item_obj, {
        headers,
      })
      .then((res) => {
        setItems(res.data);
        console.log("item", res.data);
        // console.log(
        //   "item",
        //   res.data.map(({ id, name }) => ({ id, name }))
        // );
      })
      .catch((e) => {
        console.error("Error in fetching data ", e);
      });
  };

  const fetchReport = async () => {
    var offset = (page - 1) * recordPerPage;
    setOffsetforSR((page - 1) * recordPerPage);
    try {
      const response = await axios.post(
        "/api/purple-fusion/revenuereport/supplier/item-revenue/test",
        null,
        {
          params: {
            companyId: companyId,
            startDate: formDate,
            endDate: toDate,
            supplierId: customerId < 1 ? 0 : customerId,
            itemDetailId: selectItem?.value < 1 ? 0 : selectItem?.value,
            limit: recordPerPage,
            offset: offset,
          },
          headers: headers,
        }
      );

      const data = response.data;
      if (data !== null) {
        setLoading(false);
      }

      console.log("Response data:", data);

      if (data.length > 0) {
        const excludeFields = ["irn", "item_detail_id", "count"];
        const datePattern = /^\d{2}-\d{2}-\d{4}$/;
        const dynamicColumns = Object.keys(data[0])
          .filter((key) => !excludeFields.includes(key))
          .map((key, index, array) => {
            const formattedKey = key.replace(/_/g, " ").toUpperCase();
            const isDateColumn = datePattern.test(key);
            const isTotalColumn =
              key.toLowerCase().includes("total") || index === array.length - 1;
            // Define widths based on field name
            let columnDef = {
              headerName: formattedKey,
              field: key,
              sortable: true,
              filter: true,
              resizable: true,
            };

            if (formattedKey === "SR NO") {
              columnDef.width = 95;
            } else if (formattedKey === "ITEM NAME") {
              columnDef.flex = 2; // more space
              columnDef.minWidth = 350;
            } else if (datePattern.test(key)) {
              columnDef.width = 115; // fixed width for date-named columns
            } else {
              // columnDef.flex = 1;
              columnDef.width = 150;
            }

            // Add ₹ formatter to date and total columns
            if (isDateColumn || isTotalColumn) {
              columnDef.valueFormatter = (params) =>
                params.value != null ? formatQuantity(params.value) : "";
            }

            return columnDef;
          });

        // Optionally remove the fields from data as well (not just columns)
        const filteredData = data.map((row) => {
          const filteredRow = {};
          for (const key in row) {
            if (!excludeFields.includes(key)) {
              filteredRow[key] = row[key];
            }
          }
          return filteredRow;
        });

        setColumnDefs(dynamicColumns);
        setRowData(filteredData);
        setCount(data[0].count);
      } else {
        setColumnDefs([]);
        setRowData([]);
      }
    } catch (error) {
      console.error("Failed to fetch report:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchReportTotalAmount = async () => {
    var offset = (page - 1) * recordPerPage;
    setOffsetforSR((page - 1) * recordPerPage);
    try {
      const response = await axios.post(
        "/api/purple-fusion/revenuereport/supplier/item-revenue/test/toatl_amount",
        null,
        {
          params: {
            companyId: companyId,
            startDate: formDate,
            endDate: toDate,
            supplierId: customerId < 1 ? 0 : customerId,
            itemDetailId: selectItem?.value < 1 ? 0 : selectItem?.value,
            limit: recordPerPage,
            offset: offset,
          },
          headers: headers,
        }
      );

      const data = response.data;
      if (data !== null) {
        setLoading(false);
      }
      console.log("Response data:", data);

      if (data.length > 0) {
        const excludeFields = ["irn", "item_detail_id", "count"];
        const datePattern = /^\d{2}-\d{2}-\d{4}$/;
        const dynamicColumns = Object.keys(data[0])
          .filter((key) => !excludeFields.includes(key))
          .map((key, index, array) => {
            const formattedKey = key.replace(/_/g, " ").toUpperCase();
            const isDateColumn = datePattern.test(key);
            const isTotalColumn =
              key.toLowerCase().includes("total") || index === array.length - 1;
            // Define widths based on field name
            let columnDef = {
              headerName: formattedKey,
              field: key,
              sortable: true,
              filter: true,
              resizable: true,
            };

            if (formattedKey === "SR NO") {
              columnDef.width = 95;
            } else if (formattedKey === "ITEM NAME") {
              columnDef.flex = 2; // more space
              columnDef.minWidth = 350;
            } else if (datePattern.test(key)) {
              columnDef.width = 115; // fixed width for date-named columns
            } else {
              // columnDef.flex = 1;
              columnDef.width = 150;
            }

            // Add ₹ formatter to date and total columns
            if (isDateColumn || isTotalColumn) {
              columnDef.valueFormatter = (params) =>
                params.value != null ? formatRupee(params.value) : "";
            }

            return columnDef;
          });

        // Optionally remove the fields from data as well (not just columns)
        const filteredData = data.map((row) => {
          const filteredRow = {};
          for (const key in row) {
            if (!excludeFields.includes(key)) {
              filteredRow[key] = row[key];
            }
          }
          return filteredRow;
        });

        setColumnDefs(dynamicColumns);
        setRowDataToatlAmount(filteredData);
        setCount(data[0].count);
      } else {
        setColumnDefs([]);
        setRowDataToatlAmount([]);
      }
    } catch (error) {
      console.error("Failed to fetch report:", error);
    } finally {
      setLoading(false);
    }
  };
  const filterOption = (option, inputValue) => {
    const { label, code, code_op } = option.data;

    const labelMatch =
      label?.toLowerCase().includes(inputValue.toLowerCase()) || false;
    const codeMatch =
      code?.toLowerCase().includes(inputValue.toLowerCase()) || false;
    const codeOpMatch =
      code_op?.toLowerCase().includes(inputValue.toLowerCase()) || false;

    return labelMatch || codeMatch || codeOpMatch;
  };
  const formatOptionLabel = ({ label, code, code_op }) => (
    <div style={{ display: "flex", alignItems: "center" }}>
      <div style={{ marginLeft: 0 }}>{label}</div>
      <div style={{ marginLeft: 20 }}>{code_op}</div>
      <div style={{ marginLeft: 20 }}>{code}</div>
    </div>
  );

  useEffect(() => {
    if (selectedOption === "Quantity") {
      fetchReport();
    } else {
      fetchReportTotalAmount();
    }
  }, [
    selectedOption,
    page,
    recordPerPage,
    formDate,
    toDate,
    selectItem,
    customerId,
  ]);

  const validateToDate = (newToDate) => {
    if (formDate) {
      const from = new Date(formDate);
      const maxToDate = new Date(from.setDate(from.getDate() + 366))
        .toISOString()
        .split("T")[0];

      if (newToDate > maxToDate) {
        toast.error(
          'The "To" date must be within 366 days after the "From" date.'
        );
        setToDate(maxToDate); // Reset to maximum allowed date
      } else {
        setToDate(newToDate);
      }
    }
  };

  useImperativeHandle(
    ref,
    () => {
      const downloadExcel =
        selectedOption === "Quantity"
          ? () => downloadItemRevenueReport()
          : () => downloadItemAmountRevenueReport();

      return {
        downloadExcel,
      };
    },
    [
      selectedOption,
      page,
      recordPerPage,
      formDate,
      toDate,
      selectItem,
      customerId,
    ]
  );

  const downloadItemRevenueReport = async () => {

      Swal.fire({
      title: "Processing...",
      text: "Please wait while we process your request.",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });
    try {
      const response = await axios.post(
        "/api/purple-fusion/revenuereport/supplier/item-revenue/test/download",
        {}, // Empty body
        {
          params: {
            companyId: companyId,
            companyName: companyName,
            startDate: formDate,
            endDate: toDate,
            supplierId: customerId,
            itemDetailId: selectItem?.value,
            limit: 0,
            offset: 0,
          },
          headers: headers,
          responseType: "blob",
        }
      );
      Swal.close();
      // Extract filename from Content-Disposition header
      const disposition = response.headers["content-disposition"];
      let filename = "SupplierWise_Item_Quantity_Revenue_Report.xlsx"; // default fallback

      if (disposition && disposition.includes("filename=")) {
        const match = disposition.match(/filename="?([^"]+)"?/);
        if (match && match[1]) {
          filename = match[1];
        }
      }

      // Create blob and download
      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      Swal.close();
      console.error("Download failed:", error);
      alert("Failed to download report");
    }
  };

  const downloadExcel = async () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet(
      `Item Wise Purchase Report from ${formDate} to ${toDate}`
    );

    // Add labeled title and date rows
    worksheet.addRow(["Report Name:", "Item Wise Purchase Report"]);
    worksheet.addRow(["From:", formDate]);
    worksheet.addRow(["To:", toDate]);
    worksheet.addRow(); // Empty row
    worksheet.addRow(); // Empty row

    // Header row (Row 6)
    const headers = columnDefs.map((col) => col.headerName);
    worksheet.addRow(headers);

    // Freeze pane below the header row
    worksheet.views = [{ state: "frozen", ySplit: 6 }];

    // Style header row (row 6)
    const headerRow = worksheet.getRow(6);
    headerRow.eachCell((cell) => {
      cell.font = { bold: true, color: { argb: "FFFFFFFF" } }; // White bold text
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FF0070C0" }, // Blue background
      };
      cell.alignment = { vertical: "middle", horizontal: "center" }; // Optional
    });

    // Add data rows
    rowData.forEach((row) => {
      const dataRow = columnDefs.map((col) => row[col.field]);
      worksheet.addRow(dataRow);
    });

    // Download the file
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(blob, `Item_Wise_Purchase_Report_${formDate}_${toDate}.xlsx`);
  };

  //  const downloadItemAmountRevenueReport = async ({

  // }) => {
  //   try {
  //      const response = await axios.post(
  //     "/api/purple-fusion/revenuereport/item-revenue/test/amount/download",
  //     {},  // empty object body (not null)
  //     {
  //       params: {
  //           companyId: companyId,
  //           startDate: formDate,
  //           endDate: toDate,
  //           customerId: customerId,
  //           itemDetailId: selectItem?.value,
  //           limit: 0,
  //           offset: 0,
  //         },
  //       headers: headers, // Make sure headers are exactly the same you use in fetchReport
  //       responseType: "blob",
  //     }
  //   );
  //     // Create a Blob from the response
  //     const blob = new Blob([response.data], {
  //       type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  //     });

  //     // Create a link element and trigger download
  //     const url = window.URL.createObjectURL(blob);
  //     const a = document.createElement("a");
  //     a.href = url;
  //     a.download = "item_revenue_report.xlsx";
  //     document.body.appendChild(a);
  //     a.click();
  //     a.remove();
  //     window.URL.revokeObjectURL(url);
  //   } catch (error) {
  //     console.error("Download failed:", error);
  //     alert("Failed to download report");
  //   }
  // };
  const downloadItemAmountRevenueReport = async () => {
      Swal.fire({
      title: "Processing...",
      text: "Please wait while we process your request.",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });
    try {
      const response = await axios.post(
        "/api/purple-fusion/revenuereport/supplier/item-revenue/test/amount/download",
        {}, // Empty body
        {
          params: {
            companyId: companyId,
            companyName: companyName,
            startDate: formDate,
            endDate: toDate,
            supplierId: customerId,
            itemDetailId: selectItem?.value,
            limit: 0,
            offset: 0,
          },
          headers: headers,
          responseType: "blob", // Important for downloading files
        }
      );
      Swal.close();
      // Extract filename from Content-Disposition header
      const disposition = response.headers["content-disposition"];
      let filename = "SupplierWise_Item_Amount_Revenue_Report__.xlsx"; // default fallback

      if (disposition && disposition.includes("filename=")) {
        const match = disposition.match(/filename="?(.+)"?/);
        if (match && match[1]) {
          filename = match[1];
        }
      }

      // Create blob and download
      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      Swal.close();
      console.error("Download failed:", error);
      alert("Failed to download report");
    }
  };

  const downloadExcelTotalAmount = async () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet(
      `Item Wise Purchase Report from ${formDate} to ${toDate}`
    );

    // Add labeled title and date rows
    worksheet.addRow(["Report Name:", "Item Wise Purchase Report"]);
    worksheet.addRow(["From:", formDate]);
    worksheet.addRow(["To:", toDate]);
    worksheet.addRow(); // Empty row
    worksheet.addRow(); // Empty row

    // Header row (Row 6)
    const headers = columnDefs.map((col) => col.headerName);
    worksheet.addRow(headers);

    // Freeze pane below the header row
    worksheet.views = [{ state: "frozen", ySplit: 6 }];

    // Style header row (row 6)
    const headerRow = worksheet.getRow(6);
    headerRow.eachCell((cell) => {
      cell.font = { bold: true, color: { argb: "FFFFFFFF" } }; // White bold text
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FF0070C0" }, // Blue background
      };
      cell.alignment = { vertical: "middle", horizontal: "center" }; // Optional
    });

    // Add data rows
    rowDataToatlAmount.forEach((row) => {
      const dataRow = columnDefs.map((col) => row[col.field]);
      worksheet.addRow(dataRow);
    });

    // Download the file
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(blob, `Item_Wise_Purchase_Report_${formDate}_${toDate}.xlsx`);
  };

  const customStylesSelect = {
    control: (provided) => ({
      ...provided,
      minHeight: "35px", // Adjust control height
      height: "35px", // Adjust control height
      fontSize: "14px", // Adjust font size
      width: "200px", // Adjust control width
    }),
    indicatorsContainer: (base) => ({
      ...base,
      height: "35px",
    }),
    valueContainer: (base) => ({
      ...base,
      height: "35px",
      padding: "0 8px",
    }),
    menu: (provided) => ({
      ...provided,
      width: "350px",
      backgroundColor: "#fff", // Ensures a solid background
      zIndex: 1000, // Ensures it appears above other elements
    }),
  };


  return (
    // <div className="w-full flex flex-col">
    //   <div
    //     className="ag-theme-alpine"
    //     style={{ height: "600px", width: "100%" }}
    //   >
    //     {loading ? <p>Loading...</p> : null}
    //     <AgGridReact
    //       rowData={rowData}
    //       columnDefs={columnDefs}
    //       pagination={true}
    //       paginationPageSize={20}
    //     />
    //   </div>
    // </div>
    <div>
      <div className="mb-1">
        <div className="flex flex-1 flex-row items-center justify-between w-full mt-1 pr-10 ">
          <div className="flex flex-1 flex-row items-center justify-between w-full md:flex-col md:items-start md:justify-start sm:flex-col sm:items-start sm:justify-start ">
            <div className="flex flex-row  items-center">
              <Text className="text-sm md:text-[22px] text-gray-600 sm:text-xl pt-2 mr-2 ml-2 mb-2">
                From
              </Text>
              <input
                name="from_date"
                type="date"
                value={formDate}
                // onChange={(e) => setformDate(e.target.value)}
                max={new Date().toISOString().split("T")[0]}
                onChange={(e) => {
                  setRowData([]);
                  setLoading(true);
                  setFormDate(e.target.value);
                  validateToDate(toDate); // Validate "To" date whenever "From" date changes
                }}
                className="bg-white-A700 border border-gray-400_02 border-solid h-9 rounded-[5px] text-sm"
              />
              <Text className="text-sm md:text-[22px] text-gray-600 sm:text-xl pt-2 mr-2 ml-2 mb-2">
                To
              </Text>
              <input
                name="to_date"
                type="date"
                value={toDate}
                // onChange={(e) => setToDate(e.target.value)}
                max={new Date().toISOString().split("T")[0]}
                min={formDate}
                onChange={(e) => {
                  setRowData([]);
                  setLoading(true);
                  validateToDate(e.target.value);
                }}
                className="bg-white-A700 border border-gray-400_02 border-solid h-9 rounded-[5px] text-sm"
              />

              <Select
                options={[
                  { label: "All Supplier", value: 0 },
                  ...customerList.map((customer) => ({
                    label: customer.name,
                    value: customer.id,
                  })),
                ]}
                className="bg-white-A700 border border-gray-200_02 border-solid h-8 ml-2 rounded-md w-[50%] mb-2 text-sm "
                onChange={(selectedOption) => {
                  setRowData([]);
                  setLoading(true);
                  setCustomerId(selectedOption.value);
                }}
                onInputChange={setSearchInput}
                placeholder="All Suppliers"
                styles={customStylesSelect}
              />
              <Select
                options={[
                  { label: "All Items", value: 0 },
                  ...items?.map((item) => ({
                    label: item.name,
                    value: item.id,
                    code: item.code,
                    code_op: item.code_op,
                  })),
                ]}
                className="bg-white-A700 border border-gray-200_02 border-solid h-8 ml-2 rounded-md w-[200px] mb-2 text-sm"
                onChange={(selectedOption) => {
                  setRowData([]);
                  setLoading(true);
                  setSelecteItem(selectedOption);
                }}
                filterOption={filterOption}
                formatOptionLabel={formatOptionLabel}
                onInputChange={setSearchItemsInput}
                placeholder="Select Item"
                isSearchable
                styles={customStylesSelect}
              />
            </div>
            <div className="flex items-center justify-start gap-1 sm:flex-col">
              <label className="mr-1 text-xs whitespace-nowrap ml-4">
                <input
                  id="Quantity"
                  type="radio"
                  value="Quantity"
                  checked={selectedOption === "Quantity"}
                  onChange={() => setSelectedOption("Quantity")} // Ensure event is passed
                  className="mr-1 text-xs"
                />
                Quantity
              </label>
              <label className="text-xs whitespace-nowrap">
                <input
                  id="Amount"
                  type="radio"
                  value="Amount"
                  checked={selectedOption === "Amount"}
                  onChange={() => setSelectedOption("Amount")} // Ensure event is passed
                  className="mr-1 text-xs"
                />
                Amount
              </label>
            </div>
            <div className="flex text-3xl  justify-end items-end font-inter px-[5px] leading-none  text-gray-900 md:text-4xl lg:text-5xl dark:text-white ">
              <div
                className="flex flex-col relative z-20"
                onMouseEnter={() => setDownload(!download)}
                onMouseLeave={() => setDownload(!download)}
              >
                <button
                  id="dropdownDefaultButton"
                  // data-dropdown-toggle="dropdown"
                  className="text-white-A700 bg-blue-700 hover:bg-blue-800 font-medium rounded-lg text-sm px-3 py-1.5 text-center inline-flex items-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                  type="button"
                >
                  {"Downlod"} &nbsp;{" "}
                  <svg
                    class="w-2.5 h-2.5 ms-3"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 10 6"
                  >
                    <path
                      stroke="currentColor"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="m1 1 4 4 4-4"
                    />
                  </svg>
                </button>
                <div
                  className={`${
                    download ? "absolute top-[32px]" : "hidden"
                  } z-20 bg-white divide-y divide-gray-100 rounded-lg shadow w-[125px] bg-white-A700  dark:bg-gray-700`}
                >
                  <ul
                    class="py-0 text-sm text-gray-700 dark:text-gray-200"
                    aria-labelledby="dropdownDefaultButton"
                  >
                    {selectedOption === "Quantity" && (
                      <li>
                        <span
                          className="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white"
                          onClick={downloadExcel}
                        >
                          Excel for Quantit
                        </span>
                      </li>
                    )}
                    {selectedOption === "Amount" && (
                      <li>
                        <span
                          className="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white"
                          onClick={downloadExcelTotalAmount}
                        >
                          Excel for Amount
                        </span>
                      </li>
                    )}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {selectedOption === "Quantity" && (
        <div>
          <div
            className="ag-theme-quartz"
            // style={{ height: 435, width: "100%", fontSize: "12px" }}
            id="tab-grid-table"
          >
            <AgGridReact
              rowData={rowData}
              columnDefs={columnDefs}
              ref={gridRef}
              suppressMenuHide={true}
              suppressExcelExport={true}
              rowHeight={37}
              overlayLoadingTemplate={loading ? "Loading..." : null}
              overlayNoRowsTemplate={
                loading
                  ? ' <img class="animate-spin" src="https://www.svgrepo.com/show/199956/loading-loader.svg" alt="Loading icon" style="width: 50px; height: 50px;">'
                  : "No Record Found"
              }
            />
          </div>
          <div>
            <Pagination
              count={count}
              setRecordPerPage={setRecordPerPage}
              recordPerPage={recordPerPage}
              setLoading={setLoading}
              setData={setRowData}
              setPage={setPage}
              page={page}
            />
          </div>
        </div>
      )}
      {selectedOption === "Amount" && (
        <div>
          <div
            className="ag-theme-quartz"
            style={{ height: 435, width: "100%", fontSize: "12px" }}
            id="my-table1"
          >
            <AgGridReact
              rowData={rowDataToatlAmount}
              columnDefs={columnDefs}
              ref={gridRef}
              suppressMenuHide={true}
              suppressExcelExport={true}
              rowHeight={37}
              overlayLoadingTemplate={loading ? "Loading..." : null}
              overlayNoRowsTemplate={
                loading
                  ? ' <img class="animate-spin" src="https://www.svgrepo.com/show/199956/loading-loader.svg" alt="Loading icon" style="width: 50px; height: 50px;">'
                  : "No Record Found"
              }
            />
          </div>
          <div>
            <Pagination
              count={count}
              setRecordPerPage={setRecordPerPage}
              recordPerPage={recordPerPage}
              setLoading={setLoading}
              setData={setRowDataToatlAmount}
              setPage={setPage}
              page={page}
            />
          </div>
        </div>
      )}
    </div>
  );
});

export default SupplieritemRevenueReportTest;
